module.exports = __webpack_public_path__ + "static/img/loading.cdec121.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/loading.gif
// module id = 13
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16